import type { Questionnaire } from "@/utils/gradingEngine.types";
import type { QuestionnaireId } from "@/utils/questionnaireMapping";

import q1 from "./questionnaire_1.json";
import q2 from "./questionnaire_2.json";
import q3 from "./questionnaire_3.json";
import q4 from "./questionnaire_4.json";
import q5 from "./questionnaire_5.json";
import q6 from "./questionnaire_6.json";

export const QUESTIONNAIRE_MAP: Record<string, Questionnaire> = {
  [q1.id]: q1 as unknown as Questionnaire,
  [q2.id]: q2 as unknown as Questionnaire,
  [q3.id]: q3 as unknown as Questionnaire,
  [q4.id]: q4 as unknown as Questionnaire,
  [q5.id]: q5 as unknown as Questionnaire,
  [q6.id]: q6 as unknown as Questionnaire,
};

export function isQuestionnaireId(value: unknown): value is QuestionnaireId {
  if (typeof value !== "string") return false;
  return value in QUESTIONNAIRE_MAP;
}
